<script>
    import {onMount} from "svelte";
    import Service from "../../utils/Service";

    export let config;
    export let mid;
    export let mname;
    export let onlyFeatured = false;

    const service = new Service(config.model_root);

    let customContentItems;
    let colNames = [];
    let loaded = false;
    onMount(() => {
        loadCustomContentItems(mid);
    })

    const loadCustomContentItems = async (id, reload = false) => {
        let response = await fetch(config.model_root + 'shared/contents/load_custom_contents.php?mid=' + id, {
            method: "GET"
        });
        window.scrollTo(0, 0);
        customContentItems = await response.json();
        if (!reload) {
            colNames = Object.keys(customContentItems[0])
        }
        loaded = true;
    }

</script>
{#if loaded}
    <div class="container p-sm-4 p-2">
        {#each customContentItems as product, index (product.id)}
            {#if product.product_visible === true && (onlyFeatured === true ? product.product_featured : true)}
                <div class="product-card">
                    {#if product.product_featured}
                        <div class="featured-badge">Aktion</div>
                    {/if}
                    {#if product.product_image && product.product_image.length > 0}
                        {#await service.loadFile(product.product_image[0].file_id)}
                            Lade...
                        {:then data}
                            <div class="product-tile">
                                <img
                                        src="{config.application_root}files/{data.fpath}"
                                        alt="{product.product_name}"
                                        class="product-image"
                                />
                            </div>
                        {:catch error}
                            <p class="text-muted mt-2 py-2 bg-light rounded border">
                                <i class="fas fa-exclamation-triangle pe-1"></i> Fehler beim Laden des Bildes
                            </p>
                        {/await}
                    {:else}
                        <div class="image-placeholder">Kein Bild verfügbar</div>
                    {/if}
                    <div class="price-tag">
                        {product.product_price}
                    </div>
                    <div class="title-container">
                        <h5 class="product-title text-darkgreen text-uppercase">{product.product_name}</h5>
                    </div>
                    <div class="details-container">
                        <p class="text-darkgreen">{product.product_details}</p>
                    </div>
                </div>
            {/if}
        {/each}

        {#if onlyFeatured}
            <a href="/site/{mname}-m-{mid}">
                <div class="product-card extra-page">
                    <div class="extra-content">
                        <h5 class="product-title"><i class="fas fa-angle-right"></i> Alle Angebote</h5>
                    </div>
                </div>
            </a>
        {/if}
    </div>
{/if}

<style>

    .container {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
        gap: 10px;
        margin: 0 auto;
        /*padding: 30px;*/
        background-color: #f0f0f0; /* Helle Hintergrundfarbe */
        background-image: radial-gradient(circle, #eaeaea 1px, transparent 1px);
        background-size: 10px 10px; /* Größe der Rauschmuster */
        border-radius: 8px;
        /*box-shadow: 0 0 20px rgba(0, 0, 0, 0.1); !* Leichter Schatten für das Container *!*/
    }

    @media (min-width: 768px) {
        .container {
            gap: 20px;
            grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
        }
    }

    .product-card {
        position: relative;
        background-color: #fff;
        overflow: hidden;
        border-radius: 8px;
        /*box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2); !* Schatten *!*/
        transition: transform 0.3s, box-shadow 0.3s;
        padding: 10px;
        /*border: 1px solid #e0e0e0; !* Rahmen für die Kacheln *!*/
        height: 240px; /* Einheitliche Höhe für die Kacheln */
    }

    @media (min-width: 576px) {
        .product-card {
            height: 340px; /* Einheitliche Höhe für die Kacheln */
        }
    }

    .image-placeholder {
        background-color: #ccc;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #666;
    }

    .product-tile {
        width: 100%; /* Nimmt die volle Breite ein */
        overflow: hidden; /* Schneidet überschüssige Teile ab */
        display: flex; /* Sicherstellung, dass Inhalt sauber ausgerichtet ist */
        justify-content: center; /* Horizontale Zentrierung */
        align-items: center; /* Vertikale Zentrierung */
    }

    .product-image {
        max-width: 100%; /* Nimmt die Breite des Containers ein */
        height: 100%; /* Passt sich der Höhe des Containers an */
        object-fit: cover; /* Proportionale Darstellung mit Zuschneiden */
        object-position: center; /* Zentriert den sichtbaren Bildbereich */
        border-radius: 4px; /* Abgerundete Ecken */
    }

    .product-tile, .image-placeholder {
        height: 100px; /* Einheitliche Höhe für die Kacheln */
    }

    @media (min-width: 576px) {
        .product-tile, .image-placeholder {
            height: 200px; /* Einheitliche Höhe für die Kacheln */
        }
    }

    .price-tag {
        position: absolute;
        bottom: 20px;
        right: 10px;
        background-color: #e74c3c; /* Rote Hintergrundfarbe für den Preis */
        color: white;
        padding: 8px 12px;
        font-weight: bold;
        border-radius: 20px; /* Rundere Preise */
        font-size: 1rem; /* Größere Schrift für den Preis */
    }

    .featured-badge {
        position: absolute;
        top: 20px;
        left: 20px;
        background-color: #ffcc00; /* Goldene Hintergrundfarbe */
        color: #000;
        padding: 5px 10px;
        font-weight: bold;
        border-radius: 15px; /* Abgerundete Ecken für das Badge */
    }

    .title-container {
        padding: 10px;
        background: transparent;
        display: flex;
        justify-content: center;
        align-items: center;
        border-top: 1px solid #e0e0e0; /* Linie über dem Titel */
        padding-top: 15px;
    }

    .details-container {
        padding: 10px;
        padding-right: 70px;
        background: transparent;
        display: flex;
        justify-content: left;
        align-items: center;
        padding-top: 5px;
    }

    .product-title {
        margin: 0;
        font-size: 1.02rem;
        font-weight: bold;
        text-align: center;
    }

    .details-container p {
        font-size: 11px !important;
    }

    @media (min-width: 576px) {
        .product-title {
            font-size: 1.4rem;
        }

        .details-container p {
            font-size: 17px !important;
        }
    }

    .extra-page {
        background-color: #f8f9fa; /* Heller, dezenter Hintergrund */
        color: #333; /* Dunkle Schriftfarbe */
        cursor: pointer; /* Zeiger anzeigen */
        /*border: 1px solid #dee2e6; !* Leichter Rand *!*/
        transition: transform 0.3s, box-shadow 0.3s;
        display: flex;
        align-items: center; /* Vertikale Ausrichtung */
        justify-content: center; /* Horizontale Ausrichtung */
        flex-direction: column; /* Anordnung der Inhalte */
        padding: 20px; /* Innenabstand */
        border-radius: 8px; /* Abgerundete Ecken */
    }

    .extra-page:hover {
        transform: scale(1.03); /* Leichter Zoom-Effekt */
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* Leichter Schatten */
    }

    .extra-content {
        text-align: center; /* Text zentrieren */
    }

    @media print {
        body {
            background: none; /* Entfernt Hintergrundfarben */
            color: #000; /* Setzt Schriftfarbe auf Schwarz */
            margin: 0 !important; /* Entfernt unnötige Ränder */
            padding: 0 !important;
        }

        .container {
            display: grid; /* Beibehaltung des Rasterlayouts */
            grid-template-columns: repeat(3, 1fr); /* Drei Spalten im Druck */
            width: 100%;
            max-width: none !important;
        }

        .product-card {
            page-break-inside: avoid; /* Verhindert das Teilen der Karten auf zwei Seiten */
            margin-top: 20px;
        }

        @page {
            margin: 20mm; /* Einheitlicher Seitenrand für Druck */
        }
    }

</style>
